import React, { Component } from "react";
import Tooltip from '@material-ui/core/Tooltip';
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import {withRouter} from 'react-router-dom';
import LogoutIcon from "@material-ui/icons/ExitToApp";
import {connect} from 'react-redux';
import AttachFile from "@material-ui/icons/AttachFile";
import {Typography, Badge, Button} from "@material-ui/core";
import {BLUE_COLOR,MODIFIEDBLACK,PURPLE_COLOR} from "../constants";
class AppBarTop extends Component {
  handleLogout(){
    const callback = this.props.handleLogout();
    if(callback){setTimeout(callback,10,null);}
  }

  componentDidMount() {
    //Verify Authentication
    if(!this.props.auth.data){this.props.history.push("/");}
  }

  state = { open: false , redirect: false, route: '/' };

  render() {
    var _login,_agency,_company = "";
    if(this.props.auth.data){
      const {login,agency,company} = this.props.auth.data;
      _login = login ;
      _agency = agency;
      _company = company;
    }
    return (
      <div >
        <CssBaseline />
        <AppBar
          color="default"
          position="fixed"
        >
          <Toolbar>

            <div style={{position:'absolute',right:20,display:'flex',marginTop:10}}>



              <div style={{ display:'flex'}}>
                <div style={{backgroundColor:BLUE_COLOR,borderRadius:'50%',height:40,width:40,justifyContent:'center'}}>
                  <Typography style={{color:'white',fontWeight:'bold',fontSize:18,textAlign:'center',paddingTop:6}}>{_company}</Typography>
                </div>
                <div style={{display:'column',marginLeft:10}}>
                  <Typography style={{color:MODIFIEDBLACK,fontWeight:'bold',marginTop:-2}}>{_login}</Typography>
                  <Typography style={{color:MODIFIEDBLACK,marginTop:-5}}>{_agency}</Typography>
                </div>
              </div>
              <div style={{height:35,width:1,backgroundColor:'rgba(191,193,194,1.0)',marginLeft:10,marginRight:10,marginTop:5}}/>
              <Tooltip title="Logout" aria-label="Logout">
                <IconButton color="inherit" onClick={()=>this.handleLogout()}>
                  <LogoutIcon style={{color:MODIFIEDBLACK,marginTop:-5}} fontSize={'large'}/>
                </IconButton>
              </Tooltip>
            </div>
          </Toolbar>
        </AppBar>


      </div>
    );
  }
}

const mapStateToProps = (data) =>{
  return data;
}

export default connect(mapStateToProps, {})(withRouter(AppBarTop));
